import React, { useEffect, useState } from "react";
import styles from "./ProductDetail.module.css";

import { useRouteMatch } from "react-router-dom";
import { CardDetailContainer, RecommendProduct } from "components/CardDetail";
import { Grid } from "@material-ui/core";
import { PopularProducts } from "components/CardCategories";

const ProductDetail = () => {
  const match = useRouteMatch();
  const [idProduct, setIdProduct] = useState(match.params.id);
  const myRef = React.createRef();

  useEffect(() => {
    setIdProduct(match.params.id);
    myRef.current.scrollIntoView({ behavior: "smooth" }, 500);
  }, [match.params.id]);

  useEffect(() => {}, []);

  return (
    <section className={styles.section}>
      <div className={styles.item} ref={myRef}>
        <CardDetailContainer id={parseInt(idProduct)} />
      </div>

      <div className={styles.item}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={9}>
            <RecommendProduct count={6} />
          </Grid>
          <Grid item xs={12} sm={3}>
            <PopularProducts itemOnRow={1} size={6} />
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ProductDetail;
